var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCredit = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 96,
  height: 96,
  viewBox: "0 0 96 96",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  opacity: 0.35,
  d: "M76 80H20C13.372 80 8 74.628 8 68V28C8 21.372 13.372 16 20 16H76C82.628 16 88 21.372 88 28V68C88 74.628 82.628 80 76 80Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M40 60C39.256 60 36.744 60 36 60C33.792 60 32 61.792 32 64C32 66.208 33.792 68 36 68C36.744 68 39.256 68 40 68C42.208 68 44 66.208 44 64C44 61.792 42.208 60 40 60Z",
  fill: "currentColor"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M24 60C23.256 60 20.744 60 20 60C17.792 60 16 61.792 16 64C16 66.208 17.792 68 20 68C20.744 68 23.256 68 24 68C26.208 68 28 66.208 28 64C28 61.792 26.208 60 24 60Z",
  fill: "currentColor"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M32 36C32 33.792 30.208 32 28 32C27.256 32 20.744 32 20 32C17.792 32 16 33.792 16 36C16 36.744 16 43.256 16 44C16 46.208 17.792 48 20 48C20.744 48 27.256 48 28 48C30.208 48 32 46.208 32 44C32 43.256 32 36.744 32 36Z",
  fill: "currentColor"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M56 60C55.256 60 52.744 60 52 60C49.792 60 48 61.792 48 64C48 66.208 49.792 68 52 68C52.744 68 55.256 68 56 68C58.208 68 60 66.208 60 64C60 61.792 58.208 60 56 60Z",
  fill: "currentColor"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M72 36C71.256 36 48.744 36 48 36C45.792 36 44 37.792 44 40C44 42.208 45.792 44 48 44C48.744 44 71.256 44 72 44C74.208 44 76 42.208 76 40C76 37.792 74.208 36 72 36Z",
  fill: "currentColor"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M72 60C71.256 60 68.744 60 68 60C65.792 60 64 61.792 64 64C64 66.208 65.792 68 68 68C68.744 68 71.256 68 72 68C74.208 68 76 66.208 76 64C76 61.792 74.208 60 72 60Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCredit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/credit.e063a56b.svg";
export { ForwardRef as ReactComponent };